import closeCircleFill from '@iconify/icons-eva/close-circle-fill';
import { Icon } from '@iconify/react';
import { Theme } from '@material-ui/core/styles';
import React from 'react';

// ----------------------------------------------------------------------

export default function Chip(theme: Theme, containerId: string) {
  return {
    MuiChip: {
      defaultProps: {
        container: document.getElementById(containerId),
        deleteIcon: <Icon icon={closeCircleFill} />,
      },

      styleOverrides: {
        label: {
          marginTop: -4,
        },
        colorDefault: {
          '& .MuiChip-avatarMedium, .MuiChip-avatarSmall': {
            color: theme.palette.text.secondary,
          },
        },
        outlined: {
          borderColor: theme.palette.grey[500_32],
          '&.MuiChip-colorPrimary': {
            borderColor: theme.palette.primary.main,
          },
        },
      },
    },
  };
}
